var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C9.44772 10 9 10.4477 9 11V20C9 21.1046 9.89542 22 11 22H21C22.1046 22 23 21.1046 23 20V14C23 12.8954 22.1046 12 21 12H17V11C17 10.4477 16.5523 10 16 10H10ZM10 14V20C10 20.5523 10.4477 21 11 21H21C21.5523 21 22 20.5523 22 20V14C22 13.4477 21.5523 13 21 13H11C10.4477 13 10 13.4477 10 14Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.c680ebbeb1adbeceb95cdd8fb12540bd.svg";
export { ForwardRef as ReactComponent };